import { Player } from '@lottiefiles/react-lottie-player';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import loader from '../../../../../Assets/loading.json';
import React from 'react';
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: 'rgba(0,0,0,0.3)',
    zIndex: 99999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  playerStyles: {
    height: '300px',
    width: '300px',
  },
}));

export default function Loader() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Player autoplay loop src={loader} speed={2} className={classes.playerStyles}></Player>
    </div>
  );
}